import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import { Cursor } from "./components/Cursor";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { MarqueeSection } from "./components/MarqueeSection";
import { Manifesto } from "./components/Manifesto";
import { Features } from "./components/Features";
import { Showcase } from "./components/Showcase";
import { Pricing } from "./components/Pricing";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import ReservedArea from "./components/ReservedArea";

const IntroCurtain = () => (
  <motion.div
    initial={{ y: 0 }}
    animate={{ y: "-100%" }}
    transition={{ duration: 1, delay: 1.15, ease: [0.76, 0, 0.24, 1] }}
    className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0A0A0A]"
  >
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="flex flex-col items-center gap-4"
    >
      <span className="font-bebas text-3xl tracking-[0.3em] text-[#F5F5F5]">
        METAL<span className="text-[#C5A059]">-CLASS</span>
      </span>
      <motion.span
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        className="h-px w-40 origin-left bg-[#C5A059]"
      />
    </motion.div>
  </motion.div>
);

function Landing() {
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setIntroDone(true), 2300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]">
      <AnimatePresence>{!introDone && <IntroCurtain />}</AnimatePresence>
      <div className="grain-overlay" aria-hidden />
      <Cursor />
      <Header />
      <main>
        <Hero />
        <MarqueeSection />
        <Manifesto />
        <Features />
        <Showcase />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Toaster theme="dark" position="bottom-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/accedi" element={<ReservedArea />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
